/**
 * Trunnion AI - System Metrics Bar
 * Compact horizontal metrics bar showing key system counts.
 */

import { useDashboardOverview } from '@/hooks/queries/useDashboard';

function formatTokens(count: number): string {
  if (count >= 1_000_000) return `${(count / 1_000_000).toFixed(1)}M`;
  if (count >= 1_000) return `${(count / 1_000).toFixed(1)}k`;
  return count.toLocaleString();
}

interface MetricItem {
  label: string;
  value: string;
}

export function SystemMetricsBar() {
  const { data } = useDashboardOverview();

  const metrics: MetricItem[] = [
    {
      label: 'Workflows',
      value: String(data?.totalWorkflows ?? 0),
    },
    {
      label: 'Agents',
      value: `${data?.activeAgents ?? 0} active`,
    },
    {
      label: 'Executions Today',
      value: String(data?.activeExecutions ?? 0),
    },
    {
      label: 'Tokens Today',
      value: formatTokens(data?.tokenUsageToday ?? 0),
    },
  ];

  return (
    <div className="flex items-center rounded-xl border border-trunnion-slate-700 bg-trunnion-slate-800/50 px-1">
      {metrics.map(({ label, value }, index) => (
        <div
          key={label}
          className={`flex-1 px-4 py-3 text-center ${
            index < metrics.length - 1
              ? 'border-r border-trunnion-slate-700'
              : ''
          }`}
        >
          <p className="text-lg font-bold text-white leading-tight">{value}</p>
          <p className="text-[10px] text-trunnion-slate-400 mt-0.5">{label}</p>
        </div>
      ))}
    </div>
  );
}
